/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Autosuggest from 'react-autosuggest';
import Highlighter from 'react-highlight-words';
import axiosClient from "../../../_helpers/http.helper";
import * as EmailValidator from 'email-validator';

class AutoSearch extends React.Component {
    static get propTypes () {
        return {
            debounce: PropTypes.number,
            characterLimit: PropTypes.number,
            filterResults: PropTypes.func,
            getResults: PropTypes.func,
            onInputEntered: PropTypes.func,
            onSuggestionSelected: PropTypes.func.isRequired,
            placeHolder: PropTypes.string.isRequired,
            renderSuggestion: PropTypes.func,
            searchUrl: PropTypes.string,
            theme: PropTypes.object,
            wrapperClass: PropTypes.string,
            userRoles: PropTypes.array,
            currentUser: PropTypes.object.isRequired
        };
    }

    constructor (props) {
        super(props);
        this.state = {
            suggestions: [],
            value: ''
        };
        this.getSearchResults = this.getSearchResults.bind(this);
        this.getSuggestionValue = this.getSuggestionValue.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this);
        this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this);
        this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
        this.onValueEnter = this.onValueEnter.bind(this);
        this.renderSuggestion = this.renderSuggestion.bind(this);
        this.shouldRenderSuggestions = this.shouldRenderSuggestions.bind(this);
    }

    onSuggestionSelected (event, {suggestion}) {
        this.setState({suggestions: [], value: ''});
        this.props.onSuggestionSelected(suggestion);
    }

    getSearchResults (searchText) {
        return axiosClient.get(this.props.searchUrl.replace(':searchText', searchText));
    }

    getSuggestionValue () {
        return this.state.value;
    }

    onChange (event, {newValue}) {
        this.setState({
            value: newValue,
            suggestion: []
        });
    }

    renderSuggestion (suggestion) {
        if (this.props.renderSuggestion) {
            return this.props.renderSuggestion(this.state.value, suggestion);
        } else {
            return <Highlighter
                highlightStyle={{fontWeight: 'bold', backgroundColor: 'transparent'}}
                searchWords={[this.state.value]}
                textToHighlight={suggestion.email}
            />;
        }
    }

    onSuggestionsFetchRequested ({value}) {
        const {debounce, filterResults} = this.props;
        if (this.debounced) {
            clearTimeout(this.debounced);
        }
        const debounceValue = debounce || 500;
        this.debounced = setTimeout(() => {
            this.getSearchResults(value).then(results => {
                if (filterResults) {
                    results = filterResults(results.data);
                }
                if (!(this.props.userRoles.length === 1 && (this.props.userRoles.indexOf('instructor') > -1 || this.props.userRoles.indexOf('Instructor') > -1))) {
                    this.setState({
                        suggestions: results
                    });
                }
            });
        }, debounceValue);
    }

    shouldRenderSuggestions (value) {
        return EmailValidator.validate(value);
    }

    onSuggestionsClearRequested () {
        this.setState({
            suggestions: []
        });
    }

    onValueEnter (event) {
        event.preventDefault();
        event.stopPropagation();
        if (this.state.value && this.props.onInputEntered) {
            this.props.onInputEntered(this.state.value);
            this.setState({
                value: ''
            });
        }
    }

    render () {
        const {value, suggestions } = this.state;
        const {placeHolder, theme} = this.props;
        
        const inputProps = {
            placeholder: placeHolder,
            value,
            onChange: this.onChange
        };
        return <div className="email-input-button">
            <div className="email-input">
                <Autosuggest
                    getSuggestionValue={this.getSuggestionValue}
                    inputProps={inputProps}
                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                    onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                    onSuggestionSelected={this.onSuggestionSelected}
                    renderSuggestion={this.renderSuggestion}
                    shouldRenderSuggestions={this.shouldRenderSuggestions}
                    suggestions={suggestions}
                    theme={theme}
                />
            </div>
            <button
                className={'pe-btn__primary--btn_large btn-action'.concat(EmailValidator.validate(this.state.value.trim()) ? '' : ' share-btn-disable')}
                onClick={this.onValueEnter}
                disabled={!EmailValidator.validate(this.state.value.trim())}>Add</button>
        </div>;
    }
}

export default AutoSearch;



// WEBPACK FOOTER //
// ./src/components/widgets/shareModal/AutoSearch.js